import { render, staticRenderFns } from "./PostulateProject.vue?vue&type=template&id=2f94eec8"
import script from "./PostulateProject.vue?vue&type=script&lang=js"
export * from "./PostulateProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports